<template>
  <el-dialog
    title="長期修繕預算預估"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="subtitle">
      請選擇您要預估的修繕預算時長
    </div>
    <el-select
      v-model="selectedYears"
      placeholder="請選擇"
    >
      <el-option
        v-for="item in maintenanceYearList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <div class="button-container">
      <el-button @click="handleClose">
        取消
      </el-button>
      <el-button
        type="primary"
        :disabled="isDisable"
        @click="handleSubmit"
      >
        確定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { maintenanceYearList } from '../models'
export default {
  data () {
    return {
      dialogVisible: false,
      maintenanceYearList,
      selectedYears: maintenanceYearList[0].value
    }
  },
  computed: {
    isDisable () {
      // 沒有選擇的話就不可送出
      return !this.selectedYears
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.selectedYears = maintenanceYearList[0].value
    },
    handleSubmit () {
      this.$router.push({
        name: 'changeBudget',
        params: {
          selectedYears: this.selectedYears
        }
      })
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog();
  .el-dialog__body{
    display: flex;
    flex-direction: column;
    gap: 20px;
    .subtitle{
      align-self: start;
    }
  }
}
</style>
